import { render, staticRenderFns } from "./user-service.vue?vue&type=template&id=50abc40a&scoped=true"
import script from "./user-service.vue?vue&type=script&lang=js"
export * from "./user-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50abc40a",
  null
  
)

export default component.exports